import { RootState } from '../root.reducers';
import { CfFtpInfo } from './cfFtpInfo.types';

export const getCfFtpInfoList = (state: RootState): CfFtpInfo[] =>
  state.cfFtpInfo.entities;

export const getCfFtpInfo = (state: RootState): CfFtpInfo | null =>
  state.cfFtpInfo.single;

export const getSelectedCfFtpInfo = (state: RootState): CfFtpInfo[] =>
  state.cfFtpInfo.selected;

export const getCfFtpInfoCreatedId = (state: RootState): string | null =>
  state.cfFtpInfo.createdId;

export const isCfFtpInfoCreatePopupOpen = (state: RootState): boolean =>
  state.cfFtpInfo.ui.isCreatePopupOpen;

export const isCfFtpInfoLoading = (state: RootState): boolean =>
  state.cfFtpInfo.ui.isLoading;
